import { Heading } from 'components/Heading'
import {
	MerifyIrma404Svg,
	MerifyIrmaHeadSvg,
	MerifyIrmaReviewsSvg,
	MerifyIrmaSkillsSvg,
	MerifyIrmaWorkSvg,
} from 'images'
import React from 'react'
import styled, { css } from 'styled-components'

export const noResultsStyles = css`
	display: flex;
	align-items: center;
	opacity: 0.2;
	color: ${props => props.theme.colors.secondary.val};
	&.__display-big {
		flex-direction: column;
		svg {
			width: 100%;
			height: auto;
		}
		h3 {
			line-height: 2rem;
			padding-bottom: 10px;
			text-align: center;
		}
	}
	&.__display-inline {
		flex-direction: row-reverse;
		justify-content: flex-end;
		align-items: center;
		opacity: 0.4;
		svg {
			width: 45px;
			height: auto;
		}
		h3 {
			line-height: 0.11rem;
			font-size: 0.9rem;
			padding-left: 20px;
		}
	}
`

const NoResultsView = styled.div`
	${noResultsStyles}
`

const DynamicNoResultsIrma = ({ type }: Pick<NoResultsProps, 'type'>) => {
	return (
		<>
			{type === 'skills' ? (
				<MerifyIrmaSkillsSvg />
			) : type === 'reviews' ? (
				<MerifyIrmaReviewsSvg />
			) : type === 'work' ? (
				<MerifyIrmaWorkSvg />
			) : type === 'notifications' ? (
				<MerifyIrma404Svg />
			) : (
				<MerifyIrma404Svg />
			)}
		</>
	)
}

export type NoResultsProps = {
	type?: 'skills' | 'reviews' | 'work' | 'notifications'
	display?: 'inline' | 'big'
	titleText?: string
	className?: string
}
export const NoResults = ({
	type,
	display = 'big',
	titleText = 'No Results Found',
	className,
}: NoResultsProps) => {
	return (
		<NoResultsView className={`no-results${className ? ` ${className}` : ''} __display-${display}`}>
			<Heading displayType='section-heading'>{titleText}</Heading>
			{display === 'inline' ? <MerifyIrmaHeadSvg /> : <DynamicNoResultsIrma type={type} />}
		</NoResultsView>
	)
}
